import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { footerColumns } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 pt-14 md:pt-20 pb-8 md:pb-10">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {footerColumns.map((col, idx) => (
            <div key={idx}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">
                {col.title}
              </h4>
              <div className="w-8 h-px bg-foreground-200 mb-4"></div>
              <ul className="space-y-2.5">
                {col.items.map((item) => (
                  <li key={item.id}>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                    >
                      {item.nameRu}
                    </a>
                  </li>
                ))}
                {idx === 3 && (
                  <>
                    <li>
                      <Link
                        to="/article/yoybuy-spreadsheet-guide"
                        className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                      >
                        {t('footer.guide')}
                      </Link>
                    </li>
                    <li>
                      <a
                        href="https://kaspreadsheet.com"
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                      >
                        {t('footer.faq')}
                      </a>
                    </li>
                  </>
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 md:mt-20 pt-8 border-t border-background-200/70">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end gap-6">
            <div>
              <div className="flex items-baseline gap-2">
                <span className="text-4xl md:text-5xl font-extrabold text-foreground-950 tracking-tight">
                  {t('footer.brand')}
                </span>
                <span className="text-4xl md:text-5xl font-extralight text-foreground-400 tracking-tight">
                  {t('footer.brand_sub')}
                </span>
              </div>
              <div className="mt-2 flex items-center gap-3">
                <div className="w-12 h-px bg-foreground-300"></div>
                <p className="text-xs text-foreground-500 font-light">
                  {t('footer.description')}
                </p>
              </div>
            </div>

            <div className="flex flex-col items-start sm:items-end gap-2">
              <p className="text-xs text-foreground-500">
                {t('footer.copyright')}
              </p>
              <div className="flex items-center gap-4">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-8 h-8 flex items-center justify-center text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-global-line text-lg"></i>
                  </span>
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-8 h-8 flex items-center justify-center text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-shopping-cart-line text-lg"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}